import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { (async () => {
    const { data } = await api.get("/orders"); setOrders(data || []);
  })(); }, []);

  return (
    <div className="space-y-6" data-testid="orders-page">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Orders</div>
        <h1 className="font-display text-4xl font-black tracking-tight mt-1">Order history</h1>
      </div>
      <Card className="rounded-sm border-border overflow-hidden">
        <table className="w-full text-sm dense">
          <thead className="bg-muted/40 text-left text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            <tr><th>Order</th><th>Email</th><th>Items</th><th className="text-right">Amount</th><th>Status</th><th>Date</th></tr>
          </thead>
          <tbody>
            {orders.length === 0 && <tr><td colSpan={6} className="py-10 text-center text-muted-foreground">No orders yet.</td></tr>}
            {orders.map((o) => (
              <tr key={o.order_id} className="border-t border-border" data-testid={`order-${o.order_id}`}>
                <td className="font-mono text-xs">{o.order_id}</td>
                <td>{o.email}</td>
                <td className="text-muted-foreground">{(o.items || []).map((i) => `${i.quantity}× ${i.name}`).join(", ")}</td>
                <td className="text-right font-display font-bold">${o.amount?.toFixed(2)} {o.currency?.toUpperCase()}</td>
                <td>
                  <span className={`text-[10px] uppercase tracking-[0.2em] px-2 py-1 rounded-sm ${
                    o.payment_status === "paid" ? "bg-emerald-500/10 text-emerald-600" : "bg-muted text-muted-foreground"
                  }`}>{o.payment_status}</span>
                </td>
                <td className="text-muted-foreground text-xs">{o.created_at?.slice(0,10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
